import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import PropTypes from 'prop-types'

const DashLine = ({ color = '#000', width = 5 }) => {
  return (
    <Box height="1px" overflow="hidden">
      <Typography sx={{ borderBottom: `${width}px  dashed ${color}` }} />
    </Box>
  )
}

export default React.memo(DashLine)

DashLine.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
}
